module.exports = "<svg viewBox=\"0 0 560 560\" xmlns=\"http://www.w3.org/2000/svg\"><title>tumblr</title><path d=\"M374.442 435.76c-43.872 0-78.336-34.128-78.336-60.448v-143.89h95.152v-93.888h-95.152V39.63h-65.09c0 111.2-95.568 101.824-95.568 101.824v89.97h64.433v172.144c0 63.41 58.53 116.065 129.714 116.065s94.224-28.272 94.224-28.272V407.49c0-.016-5.472 28.272-49.376 28.272z\" fill=\"#2F485D\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/icons/tumblr.svg
// module id = 576
// module chunks = 0 1 2